import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from 'react';
import {
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  Typography,
  Box
} from '@mui/material';
import {useFieldArray, Controller, useForm} from 'react-hook-form';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {useOnlineContext} from './OnlineTestContext';

interface TrueFalseQuestionTypeProps {
  question?: string;
  answer?: string;
  setQuestion?: (value: string) => void;
  setAnswer?: (value: string) => void;
  handleEditQuestion?: any;
}
interface ChildFormMethods {
  submitForm: () => Promise<any>;
}
interface Choice {
  id: number;
  OptionText: string;
  value: boolean;
}
const schema = yup.object().shape({
  QuestionText: yup.string().required('Question is required'),
  TrueFalse: yup.boolean()
});

const TrueFalseOnlineQuestionType = forwardRef<
  ChildFormMethods,
  TrueFalseQuestionTypeProps
>(({question, answer, handleEditQuestion}, ref) => {
  const {onlineData, setOnlineData} = useOnlineContext();
  const [value, setValues] = useState(handleEditQuestion?.TrueFalse || true);
  const [choices, setChoices] = useState<Choice[]>([
    {
      id: 1,
      OptionText: 'True',
      value: true
    },
    {
      id: 2,
      OptionText: 'False',
      value: false
    }
  ]);
  useEffect(() => {
    if (handleEditQuestion) {
      setValues(handleEditQuestion?.TrueFalse);
    }
  }, [handleEditQuestion]);
  const {
    control,
    handleSubmit,
    watch,
    clearErrors,
    setValue,
    trigger,
    getValues,
    formState: {errors}
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      QuestionText: handleEditQuestion?.QuestionText || '',
      TrueFalse: handleEditQuestion?.TrueFalse ?? true
    }
  });
  //console.log('handleEditQuestion', handleEditQuestion, control);

  //   const handleSubmit = () => {
  //     console.log('Question:', question);
  //     console.log('Answer:', answer);
  //     // Submit logic here
  //   };
  useImperativeHandle(ref, () => ({
    submitForm: () =>
      new Promise((resolve, reject) => {
        handleSubmit(data => {
          resolve(data); // Resolve the promise with form data
        })();
      })
  }));
  return (
    <Card variant="outlined" sx={{mx: 'auto', padding: '1vh'}}>
      <div>
        <Typography variant="h1" sx={{mt: 2, mb: 1}}>
          Question
        </Typography>
        <Controller
          name="QuestionText"
          control={control}
          render={({field}) => (
            <TextField
              {...field}
              fullWidth
              label="Write Question Here"
              variant="outlined"
              error={!!errors['QuestionText']}
              helperText={errors['QuestionText']?.message}
              sx={{mb: 2}}
            />
          )}
        />
      </div>
      <div>
        <FormControl component="fieldset">
          <FormLabel component="legend" style={{fontSize: '1rem'}}>
            Answer
          </FormLabel>
          <Box sx={{display: 'flex', alignItems: 'center', mb: 1}}>
            <Controller
              name="TrueFalse"
              control={control}
              render={({field}) => (
                <RadioGroup
                  value={field.value}
                  onChange={event => field.onChange(event.target.value)}>
                  {choices?.map(choice => (
                    <Box
                      key={choice.id}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 1
                      }}>
                      <FormControlLabel
                        control={<Radio value={choice.value} />}
                        label={choice.OptionText}
                      />
                    </Box>
                  ))}
                </RadioGroup>
              )}
            />
            {errors.TrueFalse && (
              <p style={{color: 'red', marginTop: '8px'}}>
                {errors.TrueFalse.message}
              </p>
            )}
          </Box>
        </FormControl>
      </div>
    </Card>
  );
});

export default TrueFalseOnlineQuestionType;
